import type { Signal } from '../lib/contrat';

const ORDRE: Record<string, number> = { critique: 0, attention: 1, info: 2 };
const LIBELLE: Record<string, string> = {
  critique: 'Critique',
  attention: 'Attention',
  info: 'Information',
};

/** Signaux du dossier, les plus graves en tête. */
export function Signaux({ signaux }: { signaux: Signal[] }) {
  if (!signaux || signaux.length === 0) return null;

  const tries = [...signaux].sort(
    (a, b) => (ORDRE[a.niveau] ?? 9) - (ORDRE[b.niveau] ?? 9),
  );

  return (
    <ul className="signaux">
      {tries.map((signal, index) => (
        <li key={`${signal.niveau}-${index}`} className={`signal signal--${signal.niveau}`}>
          <span className="signal-niveau" title={LIBELLE[signal.niveau] ?? signal.niveau}>
            {LIBELLE[signal.niveau] ?? signal.niveau}
          </span>
          <span className="signal-texte">{signal.texte}</span>
        </li>
      ))}
    </ul>
  );
}
